module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Outgoing-box-d77251b204a4ee5c3fc6648d4baf2622.svg";